<script setup lang="ts">
import type { CmsElementZebraCmsCertificates } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementZebraCmsCertificates;
}>();

const { headline_cert, cert_images } = props.content?.config;
</script>
<template>
  <div class="pt-6 pb-7 lg:pt-16 sm:pt-10 sm:pb-16 md:pb-18 lg:pb-20">
    <div class="container">
      <h3
        v-if="headline_cert"
        class="font-primary-font font-bold text-textcolor-primary text-[28px] md:text-[32px] mb-6"
      >
        {{ headline_cert.value }}
      </h3>
      <div class="flex flex-wrap justify-between mt-4 md:mt-12 gap-4 lg:gap-12">
        <template v-for="item in cert_images.value">
          <div v-if="item.cert_image">
            <NuxtLink
              v-if="item.cert_link.url"
              :to="item.cert_link.url"
              target="_blank"
            >
              <NuxtImg
                loading="lazy"
                format="webp"
                :src="item.cert_image.url"
                class="w-auto h-[60px] md:h-[128px]"
              />
            </NuxtLink>
            <NuxtImg
              v-else
              loading="lazy"
              format="webp"
              :src="item.cert_image.url"
              class="w-auto h-[60px] md:h-[128px]"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
